import { isNil, isEmpty } from "ramda";

const capitalize = (name) => {
	if (isNil(name) || isEmpty(name)) return "";
	return name.charAt(0).toUpperCase() + name.substring(1);
};

export default capitalize;
